/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function ($) {

    // Use this variable to set up the common and page specific functions. If you
    // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        'common': {
            init: function () {
				var anchor = $(location).attr('href').substr($(location).attr('href').lastIndexOf('/') + 1);
				if (anchor.substring(0,1) === '#') {
					if ($(anchor).hasClass('collapse')) {
						$(anchor).collapse('show');
					}

					$('html, body').animate({
						scrollTop: $(anchor).offset().top
					}, 1000);
				}
            },
            finalize: function () {

				//Sticky Header

				$(window).scroll(function () {
					var sticky = $('.home-header-bar'),
						scroll = $(window).scrollTop();
					var h = $(".home-header").outerHeight();
					if (scroll >= h) {
						sticky.addClass('sticky');
					}
					else {
						sticky.removeClass('sticky');
					}
				});

				//Tweaks and Tricks
				$(document).ready(function () {
					var safariHeight = $('.safari-height').outerHeight();
					$('.safari-comp-thumb').css('height', safariHeight);
					if($(window).width() < 992){
						$('.sticky-mobile-menu').css('position','absolute');
					}
				});
				/*******************************
				 * ACCORDION WITH TOGGLE ICONS
				 *******************************/
				function toggleIcon(e) {
					$(e.target)
						.prev('.card-header')
						.find(".accordion-toggler")
						.toggleClass('fa-angle-down fa-angle-custom-up');
				}
				$('.accordion').on('hidden.bs.collapse', toggleIcon);
				$('.accordion').on('shown.bs.collapse', toggleIcon);

				$('.close').click(function(){
					var toClose = $(this).attr('data-id');
					$('#' + toClose).removeClass('active');
					var link = '#' + toClose;
					$('a[href$="' + link + '"]').removeClass('active');
				});



				/*******************************
				 * BACK TO TOP
				 *******************************/
				$(document).ready(function() {

					// Show or hide the sticky footer button
					$(window).scroll(function() {
						if ($(this).scrollTop() > 500) {
							$('.go-top').fadeIn(300);
						} else {
							$('.go-top').fadeOut(300);
						}
					});

					// Animate the scroll to top
					$('.go-top').click(function(event) {
						event.preventDefault();
						$('html, body').animate({scrollTop: 0}, 800);
					});
				});

				/*******************************
				 * SUB PAGE LINK ACTIVE CLASS ADD
				 *******************************/
				$('.sub-page-links').each(function(){
					if(window.location.href.indexOf($(this).find('a:first').attr('href'))>-1)
					{
						$(this).addClass('active').siblings().removeClass('active');
					}
				});

				/*******************************
				 * TAB BOOTSTRAP EFFECTS
				 *******************************/
				$('.nav-tabs .nav-link').click(function(){
					$('.nav-tabs .nav-link').css('opacity',0.6);
				});
				$('.close').click(function(){
					$('.nav-tabs .nav-link').css('opacity',1);
				});
				/*******************************
				 * BURGER MENU TOGGLER
				 *******************************/
				$(function() {
					$('#bs4navbar')
						.on('shown.bs.collapse', function() {
							$('.fa-bars').addClass('hidden');
							$('.fa-close').removeClass('hidden');
						})
						.on('hidden.bs.collapse', function() {
							$('.fa-bars').removeClass('hidden');
							$('.fa-close').addClass('hidden');
						});

				});
				/*******************************
				 * SEARCH ICON
				 *******************************/
				$(document).ready(function() {
					$('.search-icon').click(function(){
						$('.search-box').css('display','block');
					});
					$('.search-box-close').click(function(){
						$('.search-box').css('display','none');
					});
				});


				//Fach Ärzt Carousel Code
				//
				// $('#partnerCarousel').carousel({
				//   interval: 10000
				// });

				$('#related_docs .carousel-item').each(function () {
					var next = $(this).next();
					if (!next.length) {
						next = $(this).siblings(':first');
					}
					next.children(':first-child').clone().appendTo($(this));

					for (var i = 0; i < 1; i++) {
						next = next.next();
						if (!next.length) {
							next = $(this).siblings(':first');
						}
						next.children(':first-child').clone().appendTo($(this));
					}
				});

				//DISABLE ENTER KEY FOR SEARCH FIELD

				$('.search-box .search-field').on('keyup keypress', function(e) {
					var keyCode = e.keyCode || e.which;
					if (keyCode === 13) {
						e.preventDefault();
						return false;
					}
				});


				//FORCE IMG-FLUID Class for all images inside Content DIV
				$(document).ready(function() {
					$('main img').addClass('img-fluid');
				});            }
        },
        // Home page
        'home': {
            init: function () {
                // JavaScript to be fired on the home page
            },
            finalize: function () {
                // JavaScript to be fired on the home page, after the init JS
            }
        },
        // About us page, note the change from about-us to about_us.
        'koronare_herzkrankheit': {
            init: function () {
            },
			finalize: function () {
            }
        }
    };

    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
            var fire;
            var namespace = Sage;
            funcname = (funcname === undefined) ? 'init' : funcname;
            fire = func !== '';
            fire = fire && namespace[func];
            fire = fire && typeof namespace[func][funcname] === 'function';

            if (fire) {
                namespace[func][funcname](args);
            }
        },
        loadEvents: function () {
            // Fire common init JS
            UTIL.fire('common');

            // Fire page-specific init JS, and then finalize JS
            $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function (i, classnm) {
                UTIL.fire(classnm);
                UTIL.fire(classnm, 'finalize');
            });

            // Fire common finalize JS
            UTIL.fire('common', 'finalize');
        }
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.


